import React, { Fragment } from "react";

import img13 from "../../../images/service/ICO/1.png";
import img14 from "../../../images/service/ICO/2.png";

import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import Benefit from "../../../components/PageSection/BenefitSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";

// ------------------------------------
// DATA
// ------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "ICO Consulting & Strategy",
    content:
      "Expert analysis and roadmap creation to ensure a successful and compliant ICO launch.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Development",
    content:
      "Robust, audited smart contracts for token creation, distribution and governance.",
  },
  {
    icon: sIcon3,
    title: "Token Launch & Distribution",
    content:
      "End-to-end token launch including whitelist creation, investor allocation and vesting implementation.",
  },
];

const benefits = [
  {
    title: "Fundraising & Liquidity",
    description:
      "ICOs empower projects to raise capital from a global pool of investors with built-in token liquidity.",
    icon: sIcon1,
  },
  {
    title: "Decentralized Ownership",
    description:
      "Distributed token ownership encourages community participation and stakeholder alignment.",
    icon: sIcon2,
  },
  {
    title: "Global Reach",
    description:
      "With ICOs, businesses can attract international backers without geographical restrictions.",
    icon: sIcon3,
  },
  {
    title: "Programmable Tokens",
    description:
      "Token standards like ERC-20 allow advanced utilities including voting, staking, and access control.",
    icon: sIcon4,
  },
  {
    title: "Lower Operational Barriers",
    description:
      "Blockchain automation reduces middlemen, lowering costs and improving transparency.",
    icon: sIcon5,
  },
  {
    title: "Community Growth",
    description:
      "ICOs foster vibrant communities that contribute to long-term project success.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is an ICO?",
    a: "An Initial Coin Offering (ICO) is a fundraising mechanism where projects sell tokens to raise capital for development, operations, and growth.",
  },
  {
    q: "How does ICO differ from IEO or STO?",
    a: "ICOs are open token sales without intermediary platforms, while IEOs are exchange-hosted and STOs are compliant with securities regulations.",
  },
  {
    q: "Which blockchain networks support ICO tokens?",
    a: "ETH, BNB Chain, Polygon, Solana and other EVM-compatible networks are commonly used for ICO token launches.",
  },
  {
    q: "Do you support post-ICO services?",
    a: "Yes. We provide ongoing support including token listing assistance, community management, and smart contract maintenance.",
  },
];

// ------------------------------------
// PAGE COMPONENT
// ------------------------------------

export default function ICODevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="ICO Development Services"
        pagesub="Launch your token with confidence and scalability"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Empower Your Token Launch with{" "}
            <span className="gradient-text">ICO Development Services</span>
          </>
        }
        subtitle={`Initial Coin Offerings remain one of the most effective ways to raise capital,
build communities, and distribute project tokens. Our ICO development services
help you design, launch, and scale your token sale from strategy to execution.`}
        buttonText="Start Your ICO"
        buttonLink="/contact"
        image={img13}
        imageAlt="ICO Development Services"
      />

      {/* ================= THEORY ================= */}
      <TheorySection
        title="What Is an Initial Coin Offering?"
        image={img14}
        paragraphs={[
          "An Initial Coin Offering (ICO) is a decentralized method of fundraising that allows blockchain projects to raise capital by selling digital tokens directly to investors. ICOs remove traditional intermediaries like banks and venture capital firms, enabling innovators to connect directly with a global audience of backers. Tokens purchased during an ICO can serve a variety of utilities, including governance rights, service access, or value transfer within an ecosystem.",
          "ICOs are typically built using standard token protocols such as ERC-20 or BEP-20, ensuring compatibility and liquidity in secondary markets. A well-executed ICO not only secures necessary funding but also establishes a strong community base, sets market trading patterns, and lays the foundation for long-term token utility and adoption.",
        ]}
      />

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our ICO Development Services"
        cards={serviceCards}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit title="Benefits of ICO Development" benefits={benefits} />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of ICO Platforms"
        subtitle="A secure, transparent, and investor-friendly infrastructure."
        features={[
          {
            icon: sIcon1,
            title: "Token Creation & Standards",
            description:
              "ERC-20, BEP-20 or custom token standards tailored to your project goals.",
          },
          {
            icon: sIcon2,
            title: "Smart Contract Automation",
            description:
              "Automated vesting, distribution, and token sale logic using audited contracts.",
          },
          {
            icon: sIcon3,
            title: "KYC/AML Integration",
            description:
              "Optional compliance workflows for regulated or institutional participation.",
          },
          {
            icon: sIcon4,
            title: "Investor Dashboard",
            description:
              "Real-time metrics, allocation tracking, and token claim interfaces.",
          },
          {
            icon: sIcon5,
            title: "Multi-Chain Deployment",
            description:
              "Launch ICOs across Ethereum, BNB Chain, Polygon, Solana and more.",
          },
          {
            icon: sIcon6,
            title: "Liquidity & Exchange Support",
            description:
              "Guidance on liquidity pool setup and exchange listing readiness.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Deep Expertise in Token Launches",
          "Secure & Scalable Smart Contracts",
          "Strategic ICO Launch Support",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
